import { Box } from '@apia/theme';
import { LinearLoader } from '../loaders';

export const LinearSpinnerLock = ({ isLocked }: { isLocked: boolean }) =>
  isLocked ? (
    <Box
      className="locker"
      style={{
        backgroundColor: 'rgb(128 128 128 / 0%)',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1200,
        transition: 'background-color 0.25s',
      }}
      ref={(el) => {
        if (el instanceof HTMLElement) {
          window.requestAnimationFrame(() => {
            el.style.backgroundColor = 'rgb(200 200 200 / 60%)';
          });
        }
      }}
    >
      <LinearLoader />
    </Box>
  ) : null;
